export const capitalize = (text: string) =>
    `${text[0].toUpperCase()}${text.slice(1)}`;

export const lowercaseFirstLetter = (string: string) =>
    string === undefined
        ? ''
        : string.charAt(0).toLowerCase() + string.slice(1);

export const uppercaseFirstLetter = (string: string) =>
    string === undefined
        ? ''
        : string.charAt(0).toUpperCase() + string.slice(1);

export const removeTags = (text: string) => text.replace(/(<([^>]+)>)/gi, '');

const removeAttributes = (html: string) =>
    html.replace(/<(\w+).*?(\s?\/)?>/gi, '<$1$2>');

/**
 * Removes most HTML tags from a string, but keeps some allowed tags, without their attributes.
 * Allowed tags are `em`, `b`, `p`, `strong`, and `i`.
 */
export const sanitizeHtml = (html: string) =>
    removeAttributes(html).replace(
        /<(?!\/?(em|b|p|strong|i|br|del)(\s?\/)?>)[^>]+>/gi,
        '',
    );
